import React, { useRef } from 'react';
import { Popover } from '@material-ui/core';
import { StyledTableCard } from './style';
import { TableCardProps } from './types';

const TableCard: React.FC<TableCardProps> = ({ isActive, name, id, children, onClick, onClose, ...other }) => {
    const tableRef = useRef(null);
    return (
        <>
            <StyledTableCard {...other} ref={tableRef} onClick={onClick}>
                {name}
            </StyledTableCard>
            <Popover
                onClose={onClose}
                anchorEl={tableRef.current}
                open={!!isActive}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
            >
                {children}
            </Popover>
        </>
    );
};

export default TableCard;
